import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSizeS = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 33.193 33.193",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "S_Banner",
		transform: "translate(-1222 -1804)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_183",
			"data-name": "Group 183",
			transform: "translate(1222 1804)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_210",
				"data-name": "Path 210",
				d: "M32.505,4.844a1.742,1.742,0,0,1,1.844,1.844V32.505a1.742,1.742,0,0,1-1.844,1.844H6.688a1.742,1.742,0,0,1-1.844-1.844V6.688A1.742,1.742,0,0,1,6.688,4.844H32.505m0-1.844H6.688A3.7,3.7,0,0,0,3,6.688V32.505a3.7,3.7,0,0,0,3.688,3.688H32.505a3.7,3.7,0,0,0,3.688-3.688V6.688A3.7,3.7,0,0,0,32.505,3Z",
				transform: "translate(-3 -3)"
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_2707",
			"data-name": "Path 2707",
			d: "M8.453,2.908a1.525,1.525,0,0,0-.594-1.293A7.8,7.8,0,0,0,5.719.665,15.166,15.166,0,0,1,3.273-.321,4,4,0,0,1,.816-3.9a3.482,3.482,0,0,1,.659-2.085A4.3,4.3,0,0,1,3.367-7.413a7.12,7.12,0,0,1,2.768-.515,6.481,6.481,0,0,1,2.754.56,4.384,4.384,0,0,1,1.877,1.58,4.134,4.134,0,0,1,.669,2.318H8.463a1.945,1.945,0,0,0-.624-1.54,2.565,2.565,0,0,0-1.753-.55A2.74,2.74,0,0,0,4.392-5.1a1.453,1.453,0,0,0-.6,1.213A1.391,1.391,0,0,0,4.5-2.708a8,8,0,0,0,2.085.891A9.008,9.008,0,0,1,10.275.075a3.768,3.768,0,0,1,1.159,2.813,3.471,3.471,0,0,1-1.416,2.937A6.2,6.2,0,0,1,6.2,6.89a7.364,7.364,0,0,1-3.031-.609A4.8,4.8,0,0,1,1.089,4.612,4.274,4.274,0,0,1,.371,2.155H3.352q0,2.387,2.853,2.387a2.775,2.775,0,0,0,1.654-.431A1.4,1.4,0,0,0,8.453,2.908Z",
			transform: "translate(1232.477 1821.181)"
		})]
	})
});
export default SvgSizeS;
